import React from 'react'
import { useTranslation } from 'react-i18next'
import { IssueEntity } from 'types/IssueEntity'
import { FactsTableRow } from '../../components/FactsTable'
import { formatInteger } from '../../../packages/utils/numberFormatters'

export function SubscribedUnitsRow({ issue }: { issue: IssueEntity }) {
    const { t, i18n } = useTranslation()
    const locale = i18n.language
    return (
        <FactsTableRow label={t('pages.issues.terms.subscribedShares')}>
            {formatInteger(issue.unitSubTotal, { locale })}
        </FactsTableRow>
    )
}
